import {
  useGetProjectTypeQuery,
  useGetFlowQuery,
  useGetPassboltFolderQuery,
  useGetOrganizationsQuery,
  useGetProjectScopeTypesQuery,
  RTK_QUERY_OPTIONS,
} from 'apiv2'
import { prepareCommonSelects } from 'helpers/prepares'

export const useProjectDictionaries = () => {
  const { data: projectTypeList, isLoading: projectTypeListLoading } =
    useGetProjectTypeQuery()

  const { data: flowList, isLoading: flowListLoading } = useGetFlowQuery(
    undefined,
    RTK_QUERY_OPTIONS.DISABLE_REFETCH_ON_FOCUS
  )

  const { data: passboltData } = useGetPassboltFolderQuery(
    undefined,
    RTK_QUERY_OPTIONS.DISABLE_REFETCH_ON_FOCUS
  )

  const { data: organizations, isLoading: organizationsLoading } =
    useGetOrganizationsQuery(
      undefined,
      RTK_QUERY_OPTIONS.DISABLE_REFETCH_ON_FOCUS
    )
  const { data: projectProperties, isLoading: projectPropertiesLoading } =
    useGetProjectScopeTypesQuery(
      undefined,
      RTK_QUERY_OPTIONS.DISABLE_REFETCH_ON_FOCUS
    )

  const isProjectDictionariesLoading =
    projectTypeListLoading ||
    flowListLoading ||
    organizationsLoading ||
    projectPropertiesLoading

  return {
    projectTypeOptions: prepareCommonSelects(projectTypeList || []),
    flowOptions: prepareCommonSelects(flowList),
    passboltOptions: prepareCommonSelects(passboltData || []),
    projectPropertiesOptions: prepareCommonSelects(projectProperties || []),
    organizations,
    isProjectDictionariesLoading,
  }
}
